export interface ContextMenuState {
  instanceId: string | null;  // null = right-clicked on empty space
  x: number;
  y: number;
}

interface ContextMenuItemProps {
  label: string;
  shortcut?: string;
  color?: string;
  hoverColor?: string;
  onClick: () => void;
}

export function ContextMenuItem({ label, shortcut, color, hoverColor, onClick }: ContextMenuItemProps) {
  const defaultHover = "var(--mantine-color-default-hover, #f1f3f5)";
  return (
    <div
      style={{
        padding: "6px 12px",
        cursor: "pointer",
        fontSize: 13,
        color: color || "inherit",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 16,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = hoverColor || defaultHover; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
      onClick={onClick}
    >
      <span>{label}</span>
      {shortcut && (
        <span style={{ fontSize: 11, color: "var(--mantine-color-dimmed, #868e96)" }}>
          {shortcut}
        </span>
      )}
    </div>
  );
}
